import React from 'react';

import { useIsBokeh } from '../hooks/use-is-bokeh';

/**
 * Only renders children when theme is `bokeh-iris`.
 */
export const IrisOnly = ({ children }: React.PropsWithChildren) => {
  const isBokeh = useIsBokeh();

  if (isBokeh) return null;

  return <>{children}</>;
};
